import { BaseQueryParams } from "../baseQuery";

import { buildEstimatorQuery } from "../../modules/Estimator/AdvancedEstimator/utils";

export const estimationSalesService = BaseQueryParams(
  "estimationSalesService",
).injectEndpoints({
  endpoints: (builder) => ({
    getSupportedPairs: builder.query({
      query: () => ({
        url: "/estimator/supported-pairs",
        method: "GET",
      }),
    }),

    getSupportedPairEntities: builder.query({
      query: ({ source, target }) => ({
        url: "/estimator/supported-pair-entities",
        method: "GET",
        params: {
          source,
          target,
        },
      }),
    }),

    getSupportedPairOptionsWithInsurances: builder.query({
      query: (args) => ({
        url: `/estimator/supported-pair-options-with-insurances${buildEstimatorQuery(
          args,
        )}`,
        method: "GET",
      }),
    }),

    getSupportedPairCalculatedData: builder.query({
      query: (args) => ({
        url: `/estimator/supported-pair-calculated-data${buildEstimatorQuery(
          args,
        )}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetSupportedPairsQuery,
  useGetSupportedPairEntitiesQuery,
  useLazyGetSupportedPairOptionsWithInsurancesQuery,
  useLazyGetSupportedPairCalculatedDataQuery,
} = estimationSalesService;
